package com.taager.numbers

actual fun Number.format(digits: Int): String =
    asDynamic().toFixed(digits) as String
